import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  value: {
    fromType: {},
    loaded: false,
    ftId: 0,
    updateMessage: ""
  }
};
const formTypeItemSlice = createSlice({
  name: "fromTypeItem",
  initialState,
  reducers: {
    loadOneFormType: (state, action) => {
      state.value = {
        formType: action.payload,
        loaded: true,
        fromTypeId: action.payload.formTypeId,
        updateMessage: "success"
      };
    },
    updateFormType: (state, action) => {
      console.log(action.payload);
      state.value = {
        formType: action.payload.data,
        loaded: true,
        fromTypeId: action.payload.data.formTypeId,
        updateMessage: "success"
      };
    }
  }
});
export const { loadOneFormType, updateFormType } = formTypeItemSlice.actions;
export default formTypeItemSlice.reducer;
